import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _parseFloat from "@babel/runtime-corejs3/core-js/parse-float";
import _repeatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/repeat";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RateInput",
  props: {
    name: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: [String, Boolean, Number],
      default: ""
    },
    min: {
      type: String,
      default: ""
    },
    max: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    calculated: {
      type: Boolean,
      default: false
    },
    autoCalculated: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    decimals: {
      type: Number,
      default: 3
    },
    percentage: {
      type: Boolean,
      default: false
    },
    allowMinus: {
      type: Boolean,
      default: false
    },
    allowPlus: {
      type: Boolean,
      default: false
    },
    formattedDecimals: {
      type: Number,
      default: 4
    }
  },
  computed: {
    formattedValue() {
      if (!this.value || this.value === "0") return 0.0;
      return _parseFloat(this.value).toFixed(this.formattedDecimals);
    },
    decimalPlaceholder() {
      var _context;
      if (this.percentage) return "0";
      return `0.${_repeatInstanceProperty(_context = "0").call(_context, this.decimals)}`;
    },
    limitValue() {
      return this.percentage ? 100 : 99.999;
    },
    currentValueSign() {
      if (!this.allowMinus && !this.allowPlus) return "";
      return this.value < 0 ? "-" : "+";
    },
    maskOptions() {
      return {
        alias: "numeric",
        negationSymbol: {
          front: this.currentValueSign
        },
        onKeyDown(event, buffer, caretPos, opts) {
          if (opts.allowPlus && event.key === "+") {
            opts.negationSymbol.front = "+";
          }
          if (opts.allowMinus && event.key === "-") {
            opts.negationSymbol.front = "-";
          }
        },
        placeholder: this.decimalPlaceholder,
        suffix: "",
        digits: this.decimals,
        greedy: false,
        showMaskOnHover: false,
        groupSeparator: ".",
        digitsOptional: false,
        rightAlign: false,
        allowMinus: this.allowMinus,
        allowPlus: this.allowPlus
      };
    }
  },
  methods: {
    handleChange({
      target
    }) {
      const value = _parseFloat(target.value);
      if (value && value > this.limitValue) {
        target.value = this.limitValue;
      }
      if (value && value < -this.limitValue) {
        target.value = -this.limitValue;
      }
      this.$emit("change", {
        target: _objectSpread(_objectSpread({}, target), {}, {
          value: target.value
        })
      });
    }
  }
});